import { useEffect, useState } from "react";
import { Calendar } from "lucide-react";
import { API, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";

export default function Integrations() {
  const [integrations, setIntegrations] = useState(null);

  useEffect(() => {
    API.get("/integrations").then((r) => setIntegrations(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="max-w-3xl space-y-4" data-testid="integrations-page">
      <div>
        <h1 className="font-display text-2xl font-bold text-slate-900">Intégrations</h1>
        <p className="mt-1 text-sm text-slate-500">Connectez des calendriers externes pour bloquer automatiquement les créneaux occupés.</p>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-5" data-testid="google-calendar-card">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50">
              <Calendar className="h-5 w-5 text-blue-600" />
            </div>
            <div>
              <h3 className="font-display text-base font-semibold text-slate-900">Google Calendar</h3>
              <p className="text-xs text-slate-500">Synchronisez les événements occupés de vos employés et créez des événements automatiquement.</p>
            </div>
          </div>
          <span className="rounded-full bg-amber-50 px-3 py-1 text-xs font-medium text-amber-700" data-testid="google-status-badge">Bientôt disponible</span>
        </div>

        <div className="mt-5 space-y-2">
          {integrations === null ? (
            <p className="text-sm text-slate-400">Chargement...</p>
          ) : integrations.length === 0 ? (
            <p className="text-sm text-slate-400">Ajoutez d'abord des employés.</p>
          ) : (
            integrations.map((i) => (
              <div key={i.employee_id} className="flex items-center justify-between rounded-lg border border-slate-100 px-4 py-3" data-testid={`integration-row-${i.employee_id}`}>
                <div>
                  <p className="text-sm font-medium text-slate-900">{i.employee_name}</p>
                  <p className="text-xs text-slate-400">{i.status === "not_connected" ? "Non connecté" : i.status}</p>
                </div>
                <Button variant="outline" size="sm" disabled data-testid={`btn-connect-google-${i.employee_id}`} title="L'intégration OAuth Google Calendar sera activée dans une prochaine version">
                  Connecter
                </Button>
              </div>
            ))
          )}
        </div>

        <p className="mt-4 rounded-lg bg-slate-50 px-4 py-3 text-xs text-slate-500">
          L'architecture d'intégration est prête (stockage des jetons OAuth, calendrier par employé, synchronisation des créneaux occupés).
          La connexion OAuth Google sera activée dans une prochaine version — aucune synchronisation n'est simulée.
        </p>
      </div>
    </div>
  );
}
